export default "__VITE_ASSET__DhQgtHNW__"